import { __ } from '@wordpress/i18n';
import type { BookingStatus } from '../typings/common/booking';

const statusLabels: Record<BookingStatus, string> = {
	pending: __('Pending', 'gp-bookings'),
	confirmed: __('Confirmed', 'gp-bookings'),
	completed: __('Completed', 'gp-bookings'),
	cancelled: __('Cancelled', 'gp-bookings'),
};

export function getStatusLabel(status: BookingStatus): string {
	return statusLabels[status] || status;
}
